<div class="change_tab_wrapper">
  <div class="modal-header" *ngIf="WindowOpen">
    <div class="col-lg-6">
      <div class="text-header inc-f" *ngIf="regulationDetailType === 2">
        RULE DETAILS
      </div>
      <!-- <div class="text-header inc-f" *ngIf="regulationDetailType === 1">
        CHANGE DETAILS
      </div> -->
    </div>
    <div class="col-lg-6 f15">
      <button class="fa fa-times pull-right" [mat-dialog-close]=""
        style="float: right;cursor: pointer;background: none;border:none" aria-hidden="true" (click)="closeAction()"
        *ngIf="this.componentOpenType=='modal' || isInnerModel"></button>
      <a href="/change-detail?id={{regulationData.id}}&detailType={{regulationDetailType}}&filterType=All&ruleArr=null&isVersion={{isVersioned}}&rulebookId={{rulebookIdForVersion}}"
        target="_blank" *ngIf="this.componentOpenType=='modal'|| isInnerModel" (click)="newWindowClick()">
        <span class="fa fa-external-link pull-right external" title="Open in New Window"></span>
      </a>

    </div>

  </div>
  <div class="change-detail-page">
    <div *ngIf="regulationDetailType !== 2">
      <app-change-viewer-analytic [regulationData]="regulationData"></app-change-viewer-analytic>
    </div>
  </div>
  <div class="row" *ngIf="regulationDetailType === 2">
    <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
    <div class="col-md-12">
      <app-progress-bar [isLoading]="isLoadingRegDetails"></app-progress-bar>
      <div class="row">
        <div class="col-md-7 pr-0 mt-3" *ngIf="isSummaryShow">
          <div class="col-md-12 pr-0">
            <div class="card card-shadow-none">
              <div class="card-header text-header inc-f">
                SUMMARY
              </div>
              <div class="card-body card-height-owner">
                <div class="row">
                  <div class="col-md-2 col-lg-2">
                    <div class="form-group">
                      <!--Here in Change Id 1 checkbox is added with 1px HW for solving the issue of opening Owner dropdown at the time of page load-->
                      <div class="left inline label-heading control-label mb-1 fw">Change Id<input type="checkbox"
                          class="custom-checkbox" />
                      </div>
                      <div class="input-group">
                        {{regulation.id}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7 col-lg-7">
                    <div class="form-group">
                      <div class="left inline label-heading control-label mb-1 fw">Part</div>
                      <div class="input-group">
                        {{regulation.part}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div class="form-group">
                      <div class="left inline label-heading control-label mb-1 fw">Regulator</div>
                      <div class="input-group">
                        {{regulation.regulator}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label class="control-label fw">Owner</label>
                    <div *ngIf="!isVersioned">
                      <mat-chip-grid #ownerList class="cdk-overlay-pane owner_chiplist">
                        <mat-chip-row *ngFor="let owner of ownerDD" [selectable]="selectable" [removable]="removable"
                          (removed)="removeOwner(owner)">
                          {{owner}}
                          <mat-icon matChipRemove
                            *ngIf="removable && currentUserRole === 'Compliance Enterprise' && !isVersioned"
                            class="clear-icons">clear
                          </mat-icon>
                        </mat-chip-row>
                        <input class="form-control form-control-sm mat-autodd-input border-bottom w-100"
                          #trigautoOwner="matAutocompleteTrigger"
                          [attr.disabled]="currentUserRole !== 'Compliance Enterprise' ? 'disabled' : null" #ownerInput
                          [formControl]="searchOwnerCntrl" [matAutocomplete]="ownerAutocomplete"
                          [matChipInputFor]="ownerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                          (matChipInputTokenEnd)="addOwner($event)">
                      </mat-chip-grid>
                      <mat-autocomplete #ownerAutocomplete="matAutocomplete"
                        (optionSelected)="selectedOwnerEvent($event)">
                        <mat-option *ngFor="let owner of searchedOwner" [value]="owner">
                          {{owner.name}}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                    <div class="tag_part" *ngIf="isVersioned && ownerDD && ownerDD.length>0">
                      <span class="tags" *ngFor="let owner of ownerDD">
                        {{owner}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 mt-3" *ngIf="isActionShow">
          <div class="col-md-12 h-100 pl-0">
            <div class="card h-100 card-shadow-none">
              <div class="card-header text-header inc-f">
                Actions
              </div>
              <div class="card-body card-height d-flex flex-column justify-content-between">
                <div class="row" *ngIf="!regulation.regulationDetails && !regulation.impactAssessmentStatus">
                  <div class="col-lg-4">
                    <div class="mb-2 text-muted cursor-pointer"
                      *ngIf="regulationDetailType === 2 && commonService.checkPlanTypeAction('LRR') && commonService.checkPlanTypeAction('LRR')">
                      <input type="checkbox" (change)="updateRulebookAction('Read')" checked *ngIf="regulation.isRead"
                        [disabled]="isVersioned" style="vertical-align: middle;" />
                      <input type="checkbox" (change)="updateRulebookAction('Read')" *ngIf="!regulation.isRead"
                        [disabled]="isVersioned" style="vertical-align: middle;" />
                      <span> Rule Read</span>
                    </div>
                    <div class="mb-2 text-muted cursor-pointer"
                      *ngIf="regulationDetailType === 2 && commonService.checkPlanTypeAction('LRA') && commonService.checkPlanTypeAction('LRA')">
                      <input type="checkbox" (change)="updateRulebookAction('Applicable')" checked
                        [disabled]="isVersioned" *ngIf="regulation.applicable" style="vertical-align: middle;" />
                      <input type="checkbox" (change)="updateRulebookAction('Applicable')" [disabled]="isVersioned"
                        *ngIf="!regulation.applicable" style="vertical-align: middle;" />
                      <span> Applicable</span>
                    </div>
                    <div class="mb-2 text-muted cursor-pointer"
                      *ngIf="regulationDetailType === 2 && commonService.checkPlanTypeAction('LRO') && commonService.checkPlanTypeAction('LRO')">
                      <input type="checkbox" (change)="updateRulebookAction('Operative')" checked
                        [disabled]="isVersioned" *ngIf="regulation.operative" style="vertical-align: middle;" />
                      <input type="checkbox" (change)="updateRulebookAction('Operative')" *ngIf="!regulation.operative"
                        [disabled]="isVersioned" style="vertical-align: middle;" />
                      <span> Operative</span>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="mb-2" *ngIf="regulationDetailType === 1 && commonService.checkPlanTypeAction('CDSIA')">
                      <a (click)="openPopUp(regulation.id)" [disabled]="isVersioned">
                        Start Impact Assessment <i *ngIf="isMovedToIA" class="fa fa-circle-o-notch fa-spin"
                          style="font-size: .875rem; line-height: 1.5;"></i>
                      </a>
                    </div>
                    <div class="mb-2 text-muted" *ngIf="regulationDetailType === 3">
                      Start Impact Assessment
                    </div>
                    <div class="mb-2" *ngIf="regulationDetailType === 2">
                      <button class="btn btn-link" (click)="addSelfAssessment()" *ngIf="!isSelfAssess"
                        [disabled]="isSelfAssess || isVersioned">
                        Start Self Assessment
                      </button>
                      <button class="btn btn-link" *ngIf="isSelfAssess" [disabled]="isVersioned" (click)="goToSelf()">Go
                        to Self Assessment</button>
                    </div>
                    <div class="mb-2 text-muted">
                      Move to Library
                    </div>
                    <div class="mb-2">
                      <!-- <a href="/self-assessment/details/self/{{selfAssessment.id}}" *ngIf="filterType === 'version'"
                        class="cursor-pointer text-primary cursor-pointer pull-right ml-2"><i
                          class="fa fa-undo text-dark"></i>
                        Current Version</a> -->
                      <span class="cursor-pointer text-blue cursor-pointer" (click)="openVersionDialog()"
                        *ngIf="!isVersioned"> Version History</span>
                      <span *ngIf="isVersioned" class="marking-changed-fields">Version {{versionNo}} </span>
                    </div>
                  </div>
                  <div class="col-lg-4 pl-13">
                    <div class="mb-2" *ngIf="regulationDetailType !== 2 && commonService.checkPlanTypeAction('CDC')">
                      <a (click)="openDialog()" [disabled]="isVersioned">Close</a>
                    </div>
                    <div class="mb-2">
                      <a href="{{regulation.hyperlink}}" target="_blank"
                        [ngClass]="regulation.hyperlink ? '' : 'disabled'">
                        <span class="fa fa-globe fw cursor-pointer text-link text-primary"></span>
                        Source Link
                      </a>
                    </div>
                    <!--Start-->
                    <div class="mb-1 text-muted"
                      *ngIf="regulationDetailType === 2 ? checkSibling(data.id, 'Previous') : checkNothing()">
                      <span class="text-blue"
                        (click)="regulationDetailType === 2 ? getSiblings('Previous') : checkNothing()">Previous</span>
                    </div>
                    <div class="text-muted"
                      *ngIf="regulationDetailType === 2 ? checkSibling(data.id, 'Next') : checkNothing()">
                      <span class="text-blue"
                        (click)="regulationDetailType === 2 ? getSiblings('Next') : checkNothing()">Next</span>
                    </div>
                    <!--End-->
                  </div>
                </div>
                <div class="row justify-content-start assesment_in"
                  *ngIf="templateNo == 2 && selfAssessmentNew?.lastApproved != null && selfAssessmentNew.approvalStatus == 'Approved' && selfAssessmentNew.assessmentStatus == 'Approved'">
                  <div class="col-md-8 text-left">
                    <strong> Self Assessment Status</strong> <br>
                    <div *ngFor="let item of selfAssessmentApprovalList"><span
                        [ngClass]="item.id == selfAssessmentNew.id ? 'green_icon' : ''"></span><a
                        (click)="changeSelfAssessment(item.id)"
                        (dblclick)="openApprovedSelfAssessment(item.id)">&nbsp;{{item.jurisdiction}} |
                        {{item.approvalStatus}} | {{item.assessmentCategory}} | {{item.userName}}</a></div>
                  </div>

                </div>
                <div class="row justify-content-start assesment_in"
                  *ngIf="templateNo == 3 ">
                  <div class="col-md-8 text-left">
                    <strong> Self Assessment Status</strong> <br>
                    <div *ngFor="let item of selfAssessmentApprovalList"><span
                        [ngClass]="item.id == selfAssessmentNew.id ? 'green_icon' : ''"></span>
                        <a>&nbsp;{{item.jurisdiction}} |
                        {{item.assessmentStatus}} | {{item.userName}}</a></div>
                  </div>

                </div>
                <div class="row"
                  *ngIf="regulation.regulationDetails && regulation.regulationDetails.id > 0 && !regulation.impactAssessmentStatus">
                  <div class="col-md-12 mb-2 text-muted">Start Impact Assessment</div>
                  <div class="col-md-12 mb-2 text-muted">Start Self Assessment</div>
                  <div class="col-md-12 mb-2 text-muted">Move to Library</div>
                  <div class="col-md-12 mb-2" *ngIf="commonService.checkPlanTypeAction('CDE')"><a
                      (click)="openDialog()">Edit</a></div>
                </div>
                <div class="row" *ngIf="regulation.impactAssessmentStatus">
                  <div class="col-md-12 mb-2 text-muted">Start Impact Assessment</div>
                  <div class="col-md-12 mb-2 text-muted">Start Self Assessment</div>
                  <div class="col-md-12 mb-2 text-muted">Move to Library</div>
                  <div class="col-md-12 mb-2 text-muted">Edit</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--card-->
      <div class="row">
        <div class="col-lg-6 pr-0 mt-2" *ngIf="isAdditionalShow">
          <div [ngClass]="isShowComparison ? 'col-lg-6 pr-0' : 'col-lg-12 pr-0'" class="h-100">
            <div class="card card-shadow-none h-100">
              <div class="card-header text-header">
                <span class="inc-f">Additional Details</span>
                <span class="pull-right text-capitalize cursor-pointer" (click)="isShowComparison = !isShowComparison"
                  *ngIf="compareData && compareData.secondItem">
                  <!-- <span *ngIf="!isShowComparison">Show Comparison <span class="fa fa-chevron-down"></span></span> -->
                  <span *ngIf="isShowComparison">Hide Comparison <span class="fa fa-chevron-up"></span></span>
                </span>
              </div>
              <div class="card-body">
                <div class="row">
                  <div [ngClass]="isShowComparison ? 'col-lg-12 mt-1 fw' : 'col-lg-3 fw'">
                    <div class="form-group">
                      <div class="left inline label-heading control-label mb-1 fw">Date</div>
                      <div class="input-group input-group-sm">
                        <input class="form-control form-control-sm" value="{{regulation.date}}" readonly>
                      </div>
                    </div>
                  </div>
                  <div [ngClass]="isShowComparison ? 'col-lg-12 fw' : 'col-lg-4 fw'">
                    <div class="form-group">
                      <div class="left inline label-heading control-label mb-1">RuleBook</div>
                      <input type="text" id="SerachText" class="form-control form-control-sm"
                        value="{{regulationDetailType === 2 ? regulation.ruleBookName : regulation.pubType}}" readonly>
                    </div>
                  </div>
                  <div [ngClass]="isShowComparison ? 'col-lg-12 fw' : 'col-lg-5 fw'">
                    <div class="form-group">
                      <div class="left inline label-heading control-label mb-1 fw">Rule ID</div>
                      <input type="text" [value]="regulation.ruleId" class="form-control form-control-sm" readonly>
                      <!-- <ng-container *ngIf="ruleTopicsForToolTip && ruleTopicsForToolTip.length>65;else tooltipTopics">
                        <ng-template #popTemplate>
                          <span class="pull-right tooltip-close" (click)="Close()">x</span>
                          <div [innerHtml]="ruleTopicsForToolTip" (mouseout)="Close()"></div>
                        </ng-template>
                        <input type="text" [value]="ruleTopicsForToolTip" triggers="click:blur"
                          class="form-control form-control-sm" [tooltip]="popTemplate" placement="left" container="body"
                          readonly>
                      </ng-container>
                      <ng-template #tooltipTopics>
                        <input type="text" [value]="ruleTopicsForToolTip" class="form-control form-control-sm" readonly>
                      </ng-template> -->
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div class="left inline label-heading control-label mb-1 fw"> Description </div>
                        <div class="text-right description_buttons">
                          <!-- <span *ngIf="!isShowDescriptionEditor"><button class="icon_btn"><lucide-icon name="languages"
                                size="16" (click)="translateDescription()" matTooltip="Translate"
                                class="text-blue-lucide"></lucide-icon></button>
                            <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                              style="font-size: .875rem; line-height: 2;"></i>
                          </span> -->
                          <span class="translate_spinner" *ngIf="!isShowDescriptionEditor"><button
                              class="icon_btn"><lucide-icon name="languages" (click)="translateDescription()"
                                matTooltip="Translate" size="16" class="text-blue-lucide"></lucide-icon></button>
                            <svg *ngIf="isAssessmentLoader" class="svg svgRaw_icon" id="Layer_1" enable-background="new 0 0 24 24"
                              height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="m18.4 5.6-1.4 1.5c-2.7-2.7-7.2-2.7-9.9 0s-2.7 7.2 0 9.9 7.2 2.7 9.9 0c1.3-1.3 2.1-3.1 2.1-4.9h2c0 5-4 9-9 9s-9-4-9-9 4-9 9-9c2.3-.1 4.6.8 6.3 2.5z" />
                            </svg>
                          </span>
                          <span *ngIf="!isShowDescriptionEditor" (click)="editButtonClick()"><button
                              class="icon_btn"><lucide-icon size="16" name="square-pen" class="text-blue-lucide"
                                matTooltip="Edit"></lucide-icon></button></span>
                          <span *ngIf="isShowDescriptionEditor" (click)="saveDescriptionButtonClick()"><button
                              class="btn btn-sm">Save</button></span>
                          <span *ngIf="isShowDescriptionEditor" (click)="cancelDescriptionButtonClick()"><button
                              class="btn btn-sm">Cancel</button></span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-8 col-md-4 text-right">
                      <a href="{{regulation.hyperlink}}" target="_blank"
                        [ngClass]="regulation.hyperlink ? '' : 'disabled'">
                        <span class="fa fa-globe fw"></span>
                        View Website Link
                      </a>
                    </div> -->
                  </div>

                  <div class="text-area-css pt-2"
                    *ngIf="regulationDetailType === 2 && isKeyAlgo && !isShowDescriptionEditor"
                    [innerHTML]="highlightedData">
                  </div>
                  <div class="pt-2" *ngIf="regulationDetailType === 2 && !isKeyAlgo && !isShowDescriptionEditor">
                    <div class="edit_status_changeViewer_group border-transparent">
                      <div class="disableText w-100" *ngIf="!compareData.firstItem">
                        <div class="ck-content" *ngIf="regulation.description | hasHtmlTags; else noHtmlTags"
                          [innerHTML]="openInNewTab(regulation.description)"></div>
                        <ng-template #noHtmlTags>
                          <mat-form-field class="disableText w-100" *ngIf="!compareData.firstItem">
                            <textarea matInput cdkTextareaAutosize disabled class="text-area-css textarea_input">
                                 {{regulation.description}}
                                </textarea>
                          </mat-form-field>
                        </ng-template>
                      </div>
                    </div>
                    <div class="pt-2 text-area-css" *ngIf="compareData.firstItem" [innerHTML]="compareData.firstItem">
                    </div>
                  </div>
                  <div class="text-area-css" *ngIf="regulationDetailType !== 2 && !isShowDescriptionEditor">
                    <mat-form-field class="disableText">
                      <textarea matInput cdkTextareaAutosize disabled>
                    {{regulation.description}}
                  </textarea>
                    </mat-form-field>
                  </div>

                  <app-ck-editor class="translate_editor" [(childVariable)]="descriptionInEditor" id="description"
                    *ngIf="isShowDescriptionEditor" [data]="descriptionInEditor"></app-ck-editor>
                  <div *ngIf="regulation.spiderLinks">
                    <ng-container *ngFor="let sl of sortArray(regulation.spiderLinks.split('||'))">
                      <ng-container *ngIf="sl">
                        <!-- <a href="{{sl.split('|')[1]}}" target="_blank">
                          <div class="highlight-text rp-highlight">{{sl.split('|')[0]}}</div>
                        </a> -->
                        <a [href]="sanitizeUrl(sl.split('|')[1])" target="_blank">
                          <div class="highlight-text rp-highlight">{{ sl.split('|')[0] }}</div>
                        </a>
                      </ng-container>
                    </ng-container>
                  </div>
                  <div *ngIf="regulation.relatedProvisions">
                    <ng-container *ngFor="let rp of sortArray(regulation.relatedProvisions.split('||'))">
                      <ng-container *ngIf="rp">
                        <ng-container *ngFor="let item of rp.split('|') let i = index">
                          <div class="highlight-para rp-highlight highlight-text" *ngIf="i % 2 === 0">
                            {{item}}</div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6" *ngIf="isShowComparison">
            <div class="card">
              <mat-accordion>
                <mat-expansion-panel [expanded]="true" class="comparison-panel">
                  <mat-expansion-panel-header aria-expanded="true" class="panel-header">
                    <mat-panel-title>
                      <div class="text-header inc-f">
                        <span class="fa fa-list"></span> Previous Version
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="row mt-3 p-2">
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">Date</div>
                        <div class="input-group input-group-sm">
                          <input class="form-control form-control-sm"
                            value="{{compareData.parentDate | date:'dd-MMM-yyyy' }}" readonly>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 fw">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1">Type</div>
                        <input type="text" id="SerachText" class="form-control form-control-sm"
                          value="{{compareData.parentRulebook}}" readonly>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">Topic</div>
                        <input type="text" [value]="compareData.parentTopic" class="form-control form-control-sm"
                          readonly>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="left inline label-heading control-label mb-1 fw"> Description </div>
                      <div class="text-area-css overflow-auto pt-2" [innerHTML]="compareData.secondItem"></div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>
        <div [ngClass]="isChartExpanded? 'tab-pane col-lg-12 mt-2' : 'tab-pane col-lg-6 mt-2'" *ngIf="isConnectionShow">
          <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
          <div class="Change_detail_card position-relative">
            <span class="float-right text-blue fa mt-1 expand_icon" role="button"
              [attr.title]="isChartExpanded ? 'Minimize' : 'Maximize'"
              [ngClass]="isChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandConnectionPanel()"></span>
            <mat-tab-group (selectedTabChange)="tabChangedInConnections($event)" animationDuration="0ms"
              class="change-details-matmdc-tab">
              <mat-tab label="Connections">
                <div class="card Change_detail_innercard">
                  <div class="card-body">
                    <div
                      *ngIf="templateNo == 2 && selfAssessmentNew?.lastApproved != null && selfAssessmentNew?.approvalStatus == 'Approved' && selfAssessmentNew.assessmentStatus == 'Approved'"
                      class="row mt-2">
                      <!--New Section for Self Assessment template 2-->
                      <!--Start-->
                      <div class="col-lg-3 mb-2">
                        <div class="form-group">
                          <div class="left inline label-heading control-label mb-1 fw">Last Approval Date</div>
                          <div class="input-group input-group-sm">
                            <input class="form-control form-control-sm" value="{{formattedApproveDate}}" readonly>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 mb-2">
                        <div class="form-group">
                          <div class="left inline label-heading control-label mb-1 fw">Judgement</div>
                          <div class="input-group input-group-sm">
                            <input class="form-control form-control-sm" value="{{selfAssessmentNew.judgement}}"
                              readonly>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 mb-2">
                        <div class="form-group">
                          <div class="left inline label-heading control-label mb-1 fw">Limitations</div>
                          <div class="input-group input-group-sm">
                            <input class="form-control form-control-sm" value="{{selfAssessmentNew.gaps}}" readonly>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 mb-2">
                        <div class="form-group">
                          <div class="left inline label-heading control-label mb-1 fw">Actions</div>
                          <div class="input-group input-group-sm">
                            <input class="form-control form-control-sm" value="{{selfAssessmentNew.enhancement}}"
                              readonly>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <mat-accordion id="Interpretations">
                          <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
                            <mat-expansion-panel-header class="ia-mat-panel">
                              <mat-panel-title>
                                <span class="text-header inc-f">
                                  Interpretations
                                </span>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                              <div class="row ml-2 mt-1">
                                <div class="col-lg-4 mr-3 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">Interpretations</div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm"
                                        value="{{selfAssessmentNew.interpretation}}" readonly>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">Interpretation Last
                                      Edited</div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm" value="{{formattedInterDate}}"
                                        readonly>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row ml-2 mt-1">
                                <div class="col-lg-12">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-3 fw">Interpretation Details
                                    </div>
                                    <div class="input-group input-group-sm">
                                      <div class="ck-content text-justify-content"
                                        [innerHTML]="selfAssessmentNew.interpretationDetails">
                                      </div>
                                    </div>
                                    <!-- <app-ck-editor [data]="selfAssessmentNew.interpretationDetailsyy" [(childVariable)]="selfAssessmentNew.interpretationDetails"
                                    id="interpretationDetails" class="f-16"></app-ck-editor> -->
                                    <!-- <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                                      *ngIf="isEditorShow" [data]="selfAssessmentNew.interpretationDetails"
                                      [userInfo]="user" [noteId]="'interpretationDetails'"
                                      [editorUsers]="selfAssessmentNew.muteOverallStatusUser"
                                      [selfAssessmentId]=""></app-ck-editor-revision> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                        <mat-accordion id="DataJudgements">
                          <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
                            <mat-expansion-panel-header class="ia-mat-panel">
                              <mat-panel-title>
                                <span class="text-header inc-f">
                                  Judgements
                                </span>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                              <div class="row ml-2 mt-1">
                                <div class="col-lg-4 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">Judgement</div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm"
                                        value="{{selfAssessmentNew.judgement}}" readonly>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">Judgement Last
                                      Edited</div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm" value="{{formattedJudgeDate}}"
                                        readonly>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">No. of Data Judgements
                                    </div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm"
                                        value="{{selfAssessmentNew.noOfJudgements}}" readonly>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row ml-2 mt-1">
                                <div class="col-lg-12">
                                  <div class="form-group">
                                    <div class="form-group">
                                      <div class="left inline label-heading control-label mb-3 fw">Judgement Details
                                      </div>
                                      <div class="input-group input-group-sm">
                                        <div class="ck-content text-justify-content"
                                          [innerHTML]="selfAssessmentNew.judgementDetails">
                                        </div>
                                      </div>
                                      <!-- <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                                        *ngIf="isEditorShow" [data]="selfAssessmentNew.judgementDetails"
                                        [userInfo]="user" [noteId]="'judgementDetails'"
                                        [editorUsers]="selfAssessmentNew.muteOverallStatusUser"
                                        [selfAssessmentId]=""></app-ck-editor-revision> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                        <mat-accordion id="ComplianceGaps">
                          <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
                            <mat-expansion-panel-header class="ia-mat-panel">
                              <mat-panel-title>
                                <span class="text-header inc-f">
                                  Limitations
                                </span>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                              <div class="row ml-2 mt-1">
                                <div class="col-lg-6 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">Gaps</div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm" value="{{selfAssessmentNew.gaps}}"
                                        readonly>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">Limitations Last Edited</div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm" value="{{formattedGapDate}}" readonly>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 mb-3">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-1 fw">No. of Gaps
                                    </div>
                                    <div class="input-group input-group-sm">
                                      <input class="form-control form-control-sm" value="{{selfAssessmentNew.noOfGaps}}"
                                        readonly>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 mb-3">
                                  <div class="left inline label-heading control-label mb-1 fw">No. of Gaps Requiring Action
                                  </div>
                                  <div class="input-group input-group-sm">
                                    <input class="form-control form-control-sm"
                                      value="{{selfAssessmentNew.noOfGapsRiskAccepted}}" readonly>
                                  </div>
                                </div>
                                <div class="col-lg-12">
                                  <div class="form-group">
                                    <div class="left inline label-heading control-label mb-3 fw">Gap Detail</div>
                                    <div class="input-group input-group-sm">
                                      <div class="ck-content text-justify-content"
                                        [innerHTML]="selfAssessmentNew.gapDetail">
                                      </div>
                                    </div>
                                    <!-- <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                                      *ngIf="isEditorShow" [data]="selfAssessmentNew.gapDetail" [userInfo]="user"
                                      [noteId]="'gapDetail'" [editorUsers]="selfAssessmentNew.muteOverallStatusUser"
                                      [selfAssessmentId]=""></app-ck-editor-revision> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                      <!--End-->
                    </div>
                    <div class="row mt-2" *ngIf="commonService.checkPlanTypeAction('LAORC')">
                      <div class="col-lg-6">
                        <button type="button" [disabled]="isVersioned" class="btn btn-primary btn-sm"
                          (click)="openRulesConnectionDialog()">Add /
                          Remove Connection</button>
                      </div>
                      <div class="col-lg-6 text-right">
                        <span [routerLink]="" class="text-primary text-link cursor-pointer"
                          (click)="expandCollapse()">Expand / Collapse All</span>
                      </div>
                    </div>
                    <div class="row mt-2" *ngIf="linkedConnectionIds && linkedConnectionIds.length>0">
                      <div class="col-12" *ngFor="let item of linkedConnectionIds">
                        <mat-accordion id="item.part">
                          <mat-expansion-panel [expanded]="isExpand"
                            class="ia-expansion-panel change_details_expansion pl-3">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <span class="headclass text-capitalize" (click)="openView(item.id, 2)">
                                  {{item.ruleBook}} {{item.part}}
                                </span>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="ml-1" [innerHTML]="showSpiderLinks(item.regulatorRuleFullRequirement)">
                              <!-- <mat-form-field class="disableText w-100">
                                <textarea matInput cdkTextareaAutosize disabled class="text-area-css textarea_input">
                                  {{item.regulatorRuleFullRequirement}}
                                 </textarea>
                              </mat-form-field> -->
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    </div>
                    <div class="applies_accross_row mt-2" *ngIf="commonService.checkPlanTypeAction('LAA')">
                      <button type="button" class="btn btn-primary btn-sm" [disabled]="isVersioned"
                        (click)="openAppliesAcrossDialog()">Applies
                        Across</button>
                      <div class="tags_part" *ngIf="linkedAppliesAcrossIds && linkedAppliesAcrossIds.length>0">
                        <span class="tag clickable" *ngFor="let item of linkedAppliesAcrossIds"
                          (click)="openView(item.id, 2)">
                          {{item.ruleBook}} {{item.ruleId}}
                        </span>
                      </div>
                    </div>
                    <div *ngIf="templateNo == 1" class="row mt-2">
                      <div class="col-lg-12 mb-2" [hidden]="isVersioned">
                        <span class="float-right">
                          <button type="button" class="btn btn-sm mr-1"
                            [ngClass]="ownerComment.length == 0 ? null:'btn-outline-primary'"
                            *ngIf="(currentUserRole === 'Compliance Enterprise' || isOwnerPresent) && !isUpdateComment"
                            [disabled]="ownerComment.length == 0" (click)="saveComment()">Add</button>
                          <button type="button" class="btn btn-sm mr-1"
                            [ngClass]="ownerComment.length == 0 ? null:'btn-outline-primary'"
                            *ngIf="(currentUserRole === 'Compliance Enterprise' || isOwnerPresent) && isUpdateComment"
                            (click)="cancelUpdateComment()">Cancel</button>
                          <button type="button" class="btn btn-sm float-right"
                            *ngIf="currentUserRole === 'Compliance Enterprise' || isOwnerPresent"
                            [disabled]="!isUpdateComment || ownerComment.length == 0"
                            (click)="updateUserComment()">Update</button>
                        </span>
                      </div>
                      <div class="col-lg-12" [hidden]="isVersioned">
                        <div class="box-shadow p-2"
                          *ngIf="currentUserRole === 'Compliance Enterprise' || isOwnerPresent">
                          <div class="header-text">
                            <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isComment"
                              (click)="isComment = true"></span>
                            <span class="fa fa-chevron-up cursor-pointer" *ngIf="isComment"
                              (click)="isComment = false"></span>
                            <span class="control-label fw">
                              Interpretation / Assumption
                            </span>
                          </div>
                          <app-ck-editor [(childVariable)]="ownerComment" id="ownerComments" *ngIf="isComment"
                            [data]="ownerComment"></app-ck-editor>
                          <!-- <ckeditor id="ownerComments" *ngIf="isComment" [editor]="Editor" [(ngModel)]="ownerComment">
                          </ckeditor> -->
                          <!-- <angular-editor id="ownerComments" *ngIf="isComment" [config]="config" [(ngModel)]="ownerComment">
                        </angular-editor> -->
                        </div>
                      </div>
                      <div class="col-lg-12" *ngIf="ownerCommentInArray && ownerCommentInArray.length > 0">
                        <div class="comments_row mt-3">
                          <div class="comment_box" *ngFor="let item of ownerCommentInArray">
                            <span class="clickable ck-content" [innerHTML]="sanitizeHtml(item[1])"
                              [disabled]="isVersioned" (click)="updateComment(item)"></span>
                            <button (click)="deleteComment(item[0])"
                              *ngIf="currentUserRole === ('Compliance Enterprise' || isOwnerPresent) && !isUpdateComment && !isVersioned"><i
                                class="pi pi-trash"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Regulatory Insights">
                <app-progress-bar [isLoading]="isLoadingBar"></app-progress-bar>
                <div class="regulator_insight_main">
                  <div class="card card-shadow-none">
                    <div class="card-header text-header">
                      <span class="inc-16">OBLIGATION</span>
                      <a class="generate-text" (click)="getSummary(regulation.id,'Obligation')">Generate</a>
                    </div>
                    <app-progress-bar [isLoading]="obligationLoading"></app-progress-bar>
                    <div class="card-body">
                      <p [innerHTML]="showText(regulation.obligation)"></p>
                    </div>
                  </div>
                  <div class="card card-shadow-none mt-2">
                    <div class="card-header text-header">
                      <span class="inc-16">RISKS</span>
                      <a class="generate-text" (click)="getSummary(regulation.id,'Risk')">Generate</a>
                    </div>
                    <app-progress-bar [isLoading]="riskLoading"></app-progress-bar>
                    <div class="card-body">
                      <p [innerHTML]="showText(regulation.risks)"></p>
                    </div>
                  </div>
                  <div class="card card-shadow-none mt-2">
                    <div class="card-header text-header">
                      <span class="inc-16">CONTROLS</span>
                      <a class="generate-text" (click)="getSummary(regulation.id,'Controls')">Generate</a>
                    </div>
                    <app-progress-bar [isLoading]="controlLoading"></app-progress-bar>
                    <div class="card-body">
                      <p [innerHTML]="showText(regulation.controls)"></p>
                    </div>
                  </div>
                  <div class="card card-shadow-none mt-2">
                    <div class="card-header text-header">
                      <span class="inc-16">Summary</span>
                      <a class="generate-text" (click)="getSummary(regulation.id,'Summary')">Generate</a>
                    </div>
                    <app-progress-bar [isLoading]="summeryLoading"></app-progress-bar>
                    <div class="card-body">
                      <p [innerHTML]="showText(regulation.summary)"></p>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>

        </div>
      </div>
      <div class="card mt-4 mb-2" id="tabView" *ngIf="regulationDetailType === 1 && isOrganizationShow">
        <div class="disabled-cont" *ngIf="user.planType < 1"></div>
        <div class="card-header text-header inc-f">
          Controls or Other Supplementary Information
          <span class="float-right text-blue fa mt-1" role="button"
            [attr.title]="isChartExpanded ? 'Minimize' : 'Maximize'"
            [ngClass]="isChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
        </div>
        <app-progress-bar [isLoading]="isLoadingRegDetails"></app-progress-bar>
        <div class="card-body">
          <iframe *ngIf="showChartCont && iframeSRC" [ngClass]="isChartExpanded ? 'height-100' : 'height-500'"
            (load)="isLoadingRegDetails=false" [class.d-none]="isLoadingRegDetails" [src]="iframeSRC"
            style="width: 100%;"></iframe>
        </div>
      </div>
      <div class="card mt-4 mb-2" *ngIf="regulationDetailType === 2 && isOrganizationShow">
        <div class="disabled-cont" *ngIf="user.planType < 1"></div>
        <div class="card-header text-header inc-f">
          Controls or Other Supplementary Information
          <span class="float-right text-blue fa mt-1" role="button"
            [attr.title]="isChartExpanded ? 'Minimize' : 'Maximize'"
            [ngClass]="isChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
        </div>
        <div class="card-body card-body-p">
          <mat-tab-group (selectedTabChange)="tabChanged($event)">
            <mat-tab label="Related Documentation">
              <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
              <div class="row mt-3 row-m-0">
                <div class="col-lg-2">
                  <form class="form-inline d-flex md-form form-sm">
                    <label class="control-label control-label-mb">Search Keys</label>
                    <input class="form-control form-control-sm width-90pr mt-2" [disabled]="isVersioned"
                      (keydown)="onEnterSearchKeys($event, 'Policy')" [(ngModel)]="policySearchText" type="text"
                      placeholder="Search" name="search" aria-label="Search" />
                    <i class="fa fa-search search-icon cursor-pointer" (click)="searchKeys('Policy')"
                      [disabled]="isVersioned" aria-hidden="true"></i>
                  </form>
                </div>
                <div class="col-lg-3">
                  <div><label class="control-label">Document</label></div>
                  <mat-form-field class="example-full-width custom-mat-form-field w-100" appearance="fill">
                    <input type="text" matInput [formControl]="controlDocumentCntrl"
                      [matAutocomplete]="autoControlDocument" (change)="linkedControlChange($event.target.value)">
                    <mat-autocomplete #autoControlDocument="matAutocomplete"
                      (optionSelected)="getSectionList($event.option.value)">
                      <mat-option *ngFor="let policy of filteredControlDocumentOptions" [value]="policy">
                        {{policy}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="col-lg-3">
                  <div><label class="control-label">Document Section</label></div>
                  <mat-form-field class="example-full-width custom-mat-form-field w-100" appearance="fill">
                    <input type="text" matInput [formControl]="controlDocumentSectionCntrl"
                      [matAutocomplete]="autoControlDocumentSection"
                      (change)="linkedControlSectionChange($event.target.value)">
                    <mat-autocomplete #autoControlDocumentSection="matAutocomplete"
                      (optionSelected)="getSubSectionList($event.option.value)">
                      <mat-option *ngFor="let section of filteredControlDocumentSectionOptions" [value]="section">
                        {{section}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="col-lg-3">
                  <div><label class="control-label">Document Sub-Section</label></div>
                  <mat-form-field class="example-full-width custom-mat-form-field w-100" appearance="fill">
                    <input type="text" matInput [formControl]="controlDocumentSubSectionCntrl"
                      [matAutocomplete]="autoControlDocumentSubSection"
                      (input)="subSectionSelected($event.target.value)">
                    <mat-autocomplete #autoControlDocumentSubSection="matAutocomplete"
                      (optionSelected)="subSectionSelected($event.option.value)">
                      <mat-option *ngFor="let section of filteredControlDocumentSubSectionOptions" [value]="section">
                        {{section}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="col-lg-1 pt-4">
                  <button class="btn btn-sm px-4" [disabled]="isLinkedControlAddButtonDisabled || isVersioned"
                    (click)="saveRuleAnalytic()">Add</button>
                </div>
                <div class="col-lg-6">
                  <div class="header-text angular_editor_header">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isReferenceTextExpan"
                      (click)="isReferenceTextExpan = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isReferenceTextExpan"
                      (click)="isReferenceTextExpan = false"></span>
                    <span class="angular_editor_heading fw">
                      Document Reference Text
                    </span>
                  </div>
                  <app-ck-editor class="reference_text" [(childVariable)]="linkedControlData.ReferenceText"
                    id="ReferenceText" *ngIf="isReferenceTextExpan"
                    [data]="linkedControlData.ReferenceText"></app-ck-editor>
                  <!-- <ckeditor id="ReferenceText" *ngIf="isReferenceTextExpan" [editor]="Editor"
                    [(ngModel)]="linkedControlData.ReferenceText"></ckeditor> -->
                  <!-- <angular-editor class="angular-editor" *ngIf="isReferenceTextExpan"
                    [(ngModel)]="linkedControlData.ReferenceText">
                  </angular-editor> -->
                </div>
                <div class="col-lg-6">
                  <div class="header-text angular_editor_header">
                    <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isGapsExpan"
                      (click)="isGapsExpan = true"></span>
                    <span class="fa fa-chevron-up cursor-pointer" *ngIf="isGapsExpan"
                      (click)="isGapsExpan = false"></span>
                    <span class="angular_editor_heading fw">
                      Gaps
                    </span>
                  </div>
                  <app-ck-editor class="reference_text" [(childVariable)]="linkedControlData.Gaps" id="Gaps"
                    *ngIf="isGapsExpan" [data]="linkedControlData.Gaps"></app-ck-editor>
                  <!-- <ckeditor id="Gaps" *ngIf="isGapsExpan" [editor]="Editor" [(ngModel)]="linkedControlData.Gaps">
                  </ckeditor> -->
                  <!-- <angular-editor class="angular-editor" *ngIf="isGapsExpan" [(ngModel)]="linkedControlData.Gaps">
                  </angular-editor> -->
                </div>
                <div class="col-lg-12 mt-3 col-p mb-1">
                  <!-- <div class="text-blue" *ngIf="(ruleAnalyticList && (ruleAnalyticList.length>0))">
                    {{endIndex}} out of {{totalCount}}
                  </div> -->
                  <div class="table-responsive box-shadow setHeight table-cont" #tableContent>
                    <table class="table table-fixed table-hover">
                      <thead>
                        <tr>
                          <th class="pointer" style="width: 8%">Date</th>
                          <th class="pointer" style="width: 12%">User</th>
                          <th class="pointerr" style="width: 12%">Document</th>
                          <th class="pointer" style="width: 12%">Document Section</th>
                          <th class="pointer" style="width: 12%">Document Sub-Section</th>
                          <th class="pointer" style="width: 12%">Document Reference Text</th>
                          <th class="pointer" style="width: 10%">Gaps</th>
                          <th class="pointer" style="width: 12%">Attachments</th>
                          <th class="pointer" style="width: 10%">Action</th>
                        </tr>
                      </thead>
                      <tbody class="policy-list-div" *ngIf="linkedControlList">
                        <app-progress-bar [isLoading]="isAttachmentLoader"></app-progress-bar>
                        <tr *ngFor="let item of linkedControlList; let i = index" (click)="clickLinkedControlRow(item)">
                          <td class="tbl-td-scroll" style="width: 8%">{{item.CreatedDateTime |
                            date:'dd-MMM-yyyy HH:mm:ss'}}</td>
                          <td class="tbl-td-scroll" style="width: 12%">{{item.UserName}}</td>
                          <td class="tbl-td-scroll" style="width: 12%">{{item.Control}}</td>
                          <td class="tbl-td-scroll" style="width: 12%">{{item.ControlSection}}</td>
                          <td class="tbl-td-scroll" style="width: 12%">{{item.ControlSubSection}}</td>
                          <td class="tbl-td-scroll" style="width: 12%">
                            <div class="ck-content" [innerHTML]="sanitizeHtml(item.ReferenceText)">
                            </div>
                          </td>
                          <td class="tbl-td-scroll" style="width: 10%">
                            <div class="ck-content" [innerHTML]="sanitizeHtml(item.Gaps)">
                            </div>
                          </td>
                          <td class="" style="width: 12%">
                            <ng-container *ngFor="let docs of getFilteredAttachments(item.Id)">
                              <div class="file-div text-center">
                                <span class="fa fa-trash pull-right delete-docs text-danger" *ngIf="!isVersioned"
                                  (click)="openUploadDeleteModel(docs.id,item.Id,i);$event.stopPropagation()"></span>
                                <span class="cursor-pointer docx-icon"
                                  (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension);$event.stopPropagation()">
                                  <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-text-o fa-2x"
                                    *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'"
                                    aria-hidden="true"></i>
                                  <i class="fa fa-file-powerpoint-o fa-2x"
                                    *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'"
                                    aria-hidden="true"></i>
                                </span>
                                <div class="data-div">{{docs.fileName}}</div>
                              </div>
                            </ng-container>
                          </td>
                          <td class="" style="width: 10%">
                            <ng-container *ngIf="!isVersioned">
                              <span class="fg-g-red"
                                (click)="removeRuleAnalytic(item.Id); $event.stopPropagation()">Delete</span>
                              | <span class="text-blue"
                                (click)="copyRuleAnalytic(item); $event.stopPropagation()">Copy</span>
                              | <span class="text-blue" (click)="uploadAttachment(item.Id); $event.stopPropagation()">
                                <i class="fa fa-upload"></i>
                                <span class="">Add Attachments
                                </span>
                                <input [id]="'uploadAttachment_' + item.Id"
                                  (change)="handleFileInput($event.target.files,item.Id,i)" type="file" multiple
                                  style="display: none" />
                              </span>
                            </ng-container>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="Map">
              <iframe *ngIf="showChartCont && iframeSRC" class="height-600" (load)="isLoadingRegDetails=false"
                [class.d-none]="isLoadingRegDetails" [src]="iframeSRC" style="width: 100%;"></iframe>
            </mat-tab>

          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>